/* Progressive enhancement of known policy headings only; no policy body changes. */
(function () {
  'use strict';
  var knownPolicies = ['refund-policy', 'privacy-policy', 'terms-of-service', 'shipping-policy', 'contact-information', 'subscription-policy', 'legal-notice'];

  function policyKey(pathname) {
    var match = pathname.match(/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?policies\/([^/]+)\/?$/i);
    return match && knownPolicies.indexOf(match[1]) !== -1 ? match[1] : null;
  }

  function pageTitle(title, previousHeading, label) {
    if (!previousHeading || title.slice(0, previousHeading.length).toLowerCase() !== previousHeading.toLowerCase()) return title;
    var suffix = title.slice(previousHeading.length);
    if (suffix && !/^\s*[-–—|·:]/.test(suffix)) return title;
    return label + suffix;
  }

  function apply(doc, pathname) {
    var key = policyKey(pathname);
    if (!key) return false;
    var configs = doc.querySelectorAll('script[data-ss-policy-headings]');
    var heading = doc.querySelector('.shopify-policy__title h1');
    if (!configs.length || !heading) return false;
    var labels;
    try { labels = JSON.parse(configs[configs.length - 1].textContent); } catch (_) { return false; }
    var label = labels && typeof labels[key] === 'string' ? labels[key].trim() : '';
    if (!label) return false;
    var previousHeading = heading.textContent.trim();
    doc.title = pageTitle(doc.title, previousHeading, label);
    heading.textContent = label;
    return true;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { policyKey: policyKey, pageTitle: pageTitle, apply: apply };
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.SSPolicyHeadings) { window.SSPolicyHeadings.refresh(); return; }
  var refresh = function () { apply(document, window.location.pathname); };
  window.SSPolicyHeadings = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
}());
